import React from 'react';
import { IconButton } from 'theme-ui';

function PencilIcon() {
  return (
    <IconButton>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.333 2.50001C11.5081 2.32491 11.716 2.18602 11.9447 2.09126C12.1735 1.9965 12.4187 1.94772 12.6663 1.94772C12.914 1.94772 13.1592 1.9965 13.3879 2.09126C13.6167 2.18602 13.8246 2.32491 13.9997 2.50001C14.1748 2.6751 14.3137 2.88297 14.4084 3.11175C14.5032 3.34052 14.552 3.58572 14.552 3.83334C14.552 4.08096 14.5032 4.32616 14.4084 4.55494C14.3137 4.78371 14.1748 4.99158 13.9997 5.16667L4.99967 14.1667L1.33301 15.1667L2.33301 11.5L11.333 2.50001Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <defs>
          <clipPath id="clip0_711_1699">
            <rect width="16" height="16" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </IconButton>
  );
}

export default PencilIcon;
